module.exports = __webpack_public_path__ + "media/images/pic/owners-fc879c74ca58b5d3b41c01036702d19d.png";